__turbopack_context__.v({
  "heading": "ElXEqG_heading",
  "imageWrap": "ElXEqG_imageWrap",
  "inner": "ElXEqG_inner",
  "manifestoImage": "ElXEqG_manifestoImage",
  "mediaFrame": "ElXEqG_mediaFrame",
  "section": "ElXEqG_section",
  "titleDim": "ElXEqG_titleDim",
  "titleLine": "ElXEqG_titleLine",
});
